import { Component, Input, OnInit } from '@angular/core';
import { BannerType } from '../../../environments/common';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent implements OnInit {

  @Input() banner: BannerType;
  @Input() viewType: string;

  constructor(){

  }

  ngOnInit(): void {
    //throw new Error('Method not implemented.');
  }

  hasValidLink(): boolean {
    const link = this.banner?.link;
    if (!link || typeof link !== 'string') {
      return false;
    }
    const trimmed = link.trim();
    if (!trimmed || trimmed === 'https://' || trimmed === 'http://') {
      return false;
    }
    return trimmed !== (this.banner?.url || '').trim();
  }

  onBannerClick(arg0: any) {
    //throw new Error('Method not implemented.');
  }

}
